"use client"
import React from "react";
import MapBoxMapWrapper from "@/components/shared/MapBoxMapWrapper";

const EmbeddedMapView = props => {
  return (
    <MapBoxMapWrapper
      addMyLocation={props.addMyLocation}
      selectedLocation={props.selectedMarker}
      selectedLayers={props.selectedLayers}
      layers={props.layers}
      locations={props.locations}
      filter={props.filter}
      onLocationClicked={props.onLocationClicked}
      onMapClicked={props.onMapClicked}
      addClass={"embed"}
      width={props.width}
      height={props.height}
      enableDraw={props.enableDraw}
      drawType={props.drawType}
      featureGroups={props.featureGroups}
      selectedFeatureGroups={props.selectedFeatureGroups}
      onFeatureClicked={props.onFeatureClicked}
      assetGroups={props.pinLayers}
      selectedPinLayers={props.selectedPinLayers}
      onAssetGroupPointClicked={props.onAssetGroupPointClicked}
      routes={props.routes}
      mapToggle={props.mapToggle}
      selectedWaypoint={props.selectedWaypoint}
      horizontalOffset={props.horizontalOffset}
      defaultZoom={props.defaultZoom}
      defaultCenter={props.defaultCenter}
      mapCenterPadding={props.mapCenterPadding}
      popupObject={props.popupObject}
    />
  );
};
export default EmbeddedMapView;
